import Vue from "vue";
import App from "./App";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import router from "./router";
import "jquery";
import VueResource from "vue-resource";
import Axios from "axios";
import querystring from "qs";
import "quill/dist/quill.snow.css";
import echarts from "echarts";
import $ from "jquery";
import VueClipboard from "vue-clipboard2";
import "babel-polyfill"; /*  */
import VueWechatTitle from "vue-wechat-title";
import "./assets/style/magic.css"; /*  */
import "./assets/iconfont/iconfont.css";
import "@/views/userCenter/shared/consumer-details-filter.css";
// import animate from "animate.css"
// Vue.use(animate)
VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);
Vue.use(VueWechatTitle);
Vue.use(ElementUI);
// Axios.defaults.baseUrl = "http://47.100.114.95:80/"
Vue.prototype.$axios = Axios;
Vue.prototype.$qs = querystring;
Vue.prototype.$echarts = echarts;
Vue.use(VueResource);
Vue.config.productionTip = false;
Vue.prototype.canshowWX = true;
//获取链接参数 eg：http://192.168.200.37:8080/#/MainClient/fileRegistration/add?key=1  用法 let data=getUrlParam("key") => data=1
Vue.prototype.getUrlParam = function (name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
  var r = window.location.href.split("?")[1]; //匹配目标参数
  r ? (r = r.match(reg)) : (r = null);
  if (r != null) return unescape(r[2]);
  return null; //返回参数值
};
//递归  删除树结构空子集  arr为数据 key为子集字段名
Vue.prototype.deletChildrenbyKuno = function (arr, key) {
  for (var i = 0; i < arr.length; i++) {
    if (arr[i][key].length == 0) {
      delete arr[i][key];
    } else {
      this.deletChildrenbyKuno(arr[i][key], key);
    }
  }
};
//跳转链接  用法：this.gotoHref('MainClient/fileRegistration') MainClient/fileRegistration 为跳转路径
Vue.prototype.gotoHref = function (src) {
  let _href = window.location.href;
  // let _host_k=_href.split("/#/")[0];
  // window.location.href= _host_k+"/#/"+src
  // let srcHref=''
  // if(src.indexOf("?")>=0){
  //   srcHref=src+'&timestamp=' + new Date().getTime()
  // }else{
  //   srcHref=src+''
  // }
  console.log("src", src);
  this.$router.push({
    path: src,
  });
};
Vue.prototype.alertbox = function (txt, timer) {
  let str = `<p>${txt}</p>`;
  this.$alert(str, "", {
    confirmButtonText: "确定",
    dangerouslyUseHTMLString: true,
    customClass: "myAlert",
    lockScroll: false,
    confirmButtonText: "知道了",
    callback: (action) => {
      this.$message({
        type: "info",
        message: `action: ${action}`,
      });
    },
  });

  return new Promise((resolve, reject) => {
    setTimeout(() => {
      $(".myAlert").find(".el-button").trigger("click");
      resolve();
    }, timer);
  });
};

//时间格式
Vue.prototype.dateFormatter = function (value, type) {
  let date;
  if (typeof value == "object") {
    date = value;
  } else {
    date = new Date(Date.parse(value.replace(/-/g, "/")));
  }
  let y = date.getFullYear();
  let MM = date.getMonth() + 1;
  MM = MM < 10 ? "0" + MM : MM;
  let d = date.getDate();
  d = d < 10 ? "0" + d : d;
  if (!!type) {
    return y + "-" + MM;
  } else {
    return y + "-" + MM + "-" + d;
  }
};
Vue.prototype.dateFormatter2 = function (value) {
  let date;
  if (typeof value == "object") {
    date = value;
  } else {
    date = new Date(Date.parse(value.replace(/-/g, "/")));
  }
  let y = date.getFullYear();
  let MM = date.getMonth() + 1;
  MM = MM < 10 ? "0" + MM : MM;
  let d = date.getDate();
  d = d < 10 ? "0" + d : d;
  var hour = date.getHours(); //得到小时
  var minu = date.getMinutes(); //得到分钟
  var sec = date.getSeconds(); //得到秒
  if (hour < 10) hour = "0" + hour;
  if (minu < 10) minu = "0" + minu;
  if (sec < 10) sec = "0" + sec;
  return y + "-" + MM + "-" + d + " " + hour + ":" + minu + ":" + sec;
};

Vue.prototype.getCurrentDate = function (format) {
  var now = new Date();
  var year = now.getFullYear(); //得到年份
  var month = now.getMonth(); //得到月份
  var date = now.getDate(); //得到日期
  var day = now.getDay(); //得到周几
  var hour = now.getHours(); //得到小时
  var minu = now.getMinutes(); //得到分钟
  var sec = now.getSeconds(); //得到秒
  month = month + 1;
  if (month < 10) month = "0" + month;
  if (date < 10) date = "0" + date;
  if (hour < 10) hour = "0" + hour;
  if (minu < 10) minu = "0" + minu;
  if (sec < 10) sec = "0" + sec;
  var time = "";
  //精确到天
  if (format == 1) {
    time = year + "-" + month + "-" + date;
  }
  //精确到分
  else if (format == 2) {
    time =
      year + "-" + month + "-" + date + " " + hour + ":" + minu + ":" + sec;
  } else if (format == 3) {
    var oneweekdate = new Date(now - 7 * 24 * 3600 * 1000);
    var y = oneweekdate.getFullYear();
    var m = oneweekdate.getMonth() + 1;
    var d = oneweekdate.getDate();
    time = y + "-" + this.add0(m) + "-" + this.add0(d);
  } else if (format == 5) {
    now.setMonth(now.getMonth() - 1);
    var y = now.getFullYear();
    var m = now.getMonth() + 1;
    var d = now.getDate();
    time = y + "-" + this.add0(m) + "-" + this.add0(d);
  } else if (format == 7) {
    var date = new Date(now);
    date.setDate(date.getDate() - 365);
    var seperator1 = "-";
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    time = year + seperator1 + month + seperator1 + strDate;
  } else if (format == 8) {
    var oneweekdate = now;
    var y = oneweekdate.getFullYear() + 10;
    var m = oneweekdate.getMonth() + 1;
    var d = oneweekdate.getDate();
    time = y + "-" + this.add0(m) + "-" + this.add0(d);
  } else if (format == 9) {
    time = year + month + date;
  }
  return time;
};
//判断是否返回登录页
Vue.prototype.returnlogin = function (value) {
  if (value.code == "2000" || value.msg == "无效的凭证") {
    //value.code=='5000'||
    if (this.canshowWX) {
      this.canshowWX = false;
      // this.gotoHref("/index");
      this.hidenavf(true);
      this.haveloginInfok(false);
      this.$message({
        message: "登录信息失效，请重新登录",
        type: "error",
        showClose: true,
        duration: 1000,
      });
      // sessionStorage.clear();
      // localStorage.clear();
      // this.showdl()
    }
    sessionStorage.setItem("showdl", "1");
    // this.gotoHref('/index')
  } else {
    if (value.msg) {
      this.$message.error(value.msg);
    }
  }
};
Vue.prototype.messageCanShow = function (el, str) {
  if (this.canshowWX) {
    this.canshowWX = false;
    el.$message.error(str);
  }
};
Vue.prototype.add0 = function (val) {
  val = parseInt(val);
  if (val < 10) {
    return "0" + val;
  } else {
    return val;
  }
};
Vue.prototype.getDateDiff = function (dateStr) {
  if (!dateStr || dateStr == "") {
    return "";
  }
  var dateTimeStamp = Date.parse(dateStr.replace(/-/gi, "/"));
  var minute = 1000 * 60;
  var hour = minute * 60;
  var day = hour * 24;
  var halfamonth = day * 15;
  let result = "";
  var month = day * 30;
  var now = new Date().getTime();
  var diffValue = now - dateTimeStamp;
  if (diffValue < 0) {
    return;
  }
  var monthC = diffValue / month;
  var weekC = diffValue / (7 * day);
  var dayC = diffValue / day;
  var hourC = diffValue / hour;
  var minC = diffValue / minute;
  if (monthC >= 1) {
    result = "" + parseInt(monthC) + "月前";
  } else if (weekC >= 1) {
    result = "" + parseInt(weekC) + "周前";
  } else if (dayC >= 1) {
    result = "" + parseInt(dayC) + "天前";
  } else if (hourC >= 1) {
    result = "" + parseInt(hourC) + "小时前";
  } else if (minC >= 1) {
    result = "" + parseInt(minC) + "分钟前";
  } else result = "刚刚";
  return result;
};
Vue.prototype.textareaTo = function (str) {
  var reg = new RegExp("\n", "g");
  var regSpace = new RegExp(" ", "g");

  str = str.replace(reg, "<br>");
  str = str.replace(regSpace, "&nbsp;");

  return str;
};
Vue.prototype.toTextarea = function (str) {
  var reg = new RegExp("<br>", "g");
  var regSpace = new RegExp("&nbsp;", "g");

  str = str.replace(reg, "\n");
  str = str.replace(regSpace, " ");

  return str;
};
import areaUtils from "../src/util/area";
Vue.prototype.$areaUtils = areaUtils;
import getUserIP from "../src/util/getip";
Vue.prototype.$getUserIP = getUserIP;

// 多语言挂载
import i18n from "./assets/lang";

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  i18n,
  components: {
    App,
  },
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js